module.exports = __webpack_public_path__ + "img/football-assist.0ed52262.png";